<template>
  <DialogLayout
    :title="title"
    :visible.sync="dialogVisible"
    width="40em"
    @open="open"
  >
    <template #form>
      <UserMasterForm
        ref="userForm"
        v-model="userFormModel"
        label-width="10em"
        formMode="edit"
        :programName="programName"
        :forgotPassword="forgotPassword"
      />
    </template>
    <template #footer>
      <EditDialogFooter
        @update="clickUpdate"
      />
    </template>
 </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/templates/DialogLayout.vue'
import UserMasterForm from '@/components/organisms/dialog/master/UserMasterForm.vue'
import EditDialogFooter from '@/components/organisms/dialog/EditDialogFooter.vue'

export default {
  components: {
    DialogLayout,
    UserMasterForm,
    EditDialogFooter
  },
  props: {
    currentRow: {
      type: Object,
      default: () => {
        return {}
      }
    },
    programName: {
      type: String,
      default: 'UserMasterChangePassword'
    },
    title: {
      type: String,
      default: 'パスワード変更'
    },
    visible: Boolean,
    forgotPassword: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      userFormModel: {
        user_id: undefined,
        login_user_id: undefined,
        password: undefined,
        password_confirm: undefined,
        verify_code: undefined,
        updated_on: undefined
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (visible) {
        this.$emit('update:visible', visible)
      }
    }
  },
  mounted () {},
  methods: {
    async clickUpdate () {
      if (!(await this.$fcMessage.messageBox(this.title, 'CMN0001W'))) {
        return
      }
      try {
        this.$loadingMask.on()
        var passwordMessage = await this.checkPassword(this.userFormModel.password, this.userFormModel.password_confirm)
        if (passwordMessage === '') {
          const params = { ...this.userFormModel }
          if (!this.forgotPassword) {
            params.verify_code = ''
          }
          this.$axios.put('/user/password', params)
            .then((res) => {
              this.$fcMessage.showMessage(res.data.message)
              this.dialogVisible = false
              this.$loadingMask.off()
            })
            .catch((e) => {
              console.log(e)
              // this.errorType = e.response.data.message
              this.$fcMessage.showMessage(e.response.data.message, true)
              // if (e.response) {
              //   switch (e.response.status) {
              //     case 402:
              //       this.$fcMessage.showMessage(e.response.data.message)
              //       break
              //     default:
              //   }
              // }
            })
        } else {
          await this.$fcMessage.showMessage(passwordMessage)
        }
      } catch (e) {
        alert(e)
      } finally {
        this.$loadingMask.off()
      }
    },
    open () {
      const trimItem = ['user_id']
      this.$nextTick(() => {
        this.$refs.userForm.clearFields()
        Object.keys(this.userFormModel)
          .forEach((x) => {
            if (trimItem.includes(x)) {
              this.currentRow[x] = this.currentRow[x].trimEnd()
            }
            this.$set(this.userFormModel, x, this.currentRow[x])
          })
      })
    }
  }
}
</script>

<style lang="scss">
</style>
